export default __webpack_public_path__ + "static/media/Ellucian_Hero.22062dfb.png";